import React, {useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {acceptorsListSelector} from '../../../../redux/selectors/acceptors';
import {filterAcceptorsList} from '../../../../shared/components/acceptorsFilter/pipes';
import {AcceptorsFilterForm} from '../../../../shared/components/acceptorsFilter/model';
import View from './view';

const paginationSize = 12;

interface Props {
  filter?: AcceptorsFilterForm;
  currentAcceptorId?: number;
}

export const LoyaltyAcceptorsList: React.FC<Props> = ({filter, currentAcceptorId}) => {
  const acceptorsList = useSelector(acceptorsListSelector(filterAcceptorsList(filter)));
  const [visibleElementsCount, setVisibleElementsCount] = useState(paginationSize);
  const canShowMore = useMemo(
    () => (acceptorsList?.length || 0) > visibleElementsCount,
    [acceptorsList, visibleElementsCount],
  );

  const filterListByCurrentId = useMemo(() => {
    let list = acceptorsList;
    if (currentAcceptorId && acceptorsList) {
      list = acceptorsList.filter((acceptor) => acceptor.id !== currentAcceptorId);
    }
    return list;
  }, [acceptorsList, currentAcceptorId]);

  const visibleAcceptorsList = filterListByCurrentId
    ? filterListByCurrentId?.slice(0, visibleElementsCount) ?? []
    : null;

  return (
    <View
      acceptorsList={visibleAcceptorsList}
      onShowMore={() => setVisibleElementsCount(visibleElementsCount + paginationSize)}
      canShowMore={canShowMore}
    />
  );
};
